import { Injectable } from '@angular/core';

import { RestService } from "../../../core/services/rest.service";
import { Obrigacao } from "./obrigacao.model";
import { apiName } from "./data.service";

@Injectable()
export class ObrigacaoApiService {

  constructor(
    private _restService: RestService
  ) { }

  onPost(object: Obrigacao, done: any) {
    this._restService.onPost(apiName, object, done);
  }

  onPut(object: Obrigacao, done: any) {
    this._restService.onPut(apiName, object, done);
  }

  onDelete(objectId: number, done: any) {
    this._restService.onDelete(apiName, objectId, done);
  }

  onGetAll(done: any) {
    var filter: any = {"order":"dataVencimento","include":["tipoObrigacao","bem"]};
    this._restService.onGetPost(apiName, filter, done);
  }

  onGetById(objectId: number, done: any) {
    var filter: any = {"include":["tipoObrigacao","bem"]};
    this._restService.onGetPostId(apiName, objectId, filter, done);
  }

  onGetApiUrl() {
    return apiName;
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/obrigacoes/shared/obrigacao-api.service.ts
 **/